import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class WorkspaceService {
    async syncUserLocations(organisationId: string, environmentName: string) {
        const response = await getAuthenticatedFetch()(`${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Workspace/syncUserLocations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                organisationId,
                environmentName
            })
        });
        
        if (!response.ok) {
            const errorBody = await response.text();
            throw new Error(`API call failed: ${response.status} - ${errorBody}`);
        }
        
        return response;
    }    
}

export default new WorkspaceService();
